import {GetRequest, PostRequest} from "./Requests";
import ApiResponse from "../Models/ApiResponse";
import { ApiConstants, ServerURL } from "./ApiConstants";

const TriviaGamePlayed = async (v: any) => {
    let apiResponse;
    if (ApiConstants.RUN_PROD_SERVER || process.env.NODE_ENV !== "development") {
        apiResponse = await PostRequest(ServerURL("/trivia/done"), v)
    } else {
        apiResponse = new ApiResponse(dummyPlans(), 200, null)
    }
    if (apiResponse.body) {
        return apiResponse.body;
    } else {
        return apiResponse.error
    }
};

function dummyPlans() {
    return {"data":{"code":"15D45D","text":"Here is your 5 code. Thanks for playing.","share":false,"value":5,"type":"percentage","expiry":null},"success":true,"error":null}
}

export default TriviaGamePlayed
